export const CART_UPDATED_EVENT = 'cart:updated'

export function emitCartUpdated() {
  try {
    window.dispatchEvent(new Event(CART_UPDATED_EVENT))
  } catch (error) {
    console.error('Cart Update Event dispatched', error)
  }
}
